import NextLink from "next/link";
import { config } from "@/config";
import { SvgName } from "@/svg";
import { Vector } from "@/components/ui/vector";
import { Typography } from "@/components/ui";
import { useSocial, UseSocialProps } from "./use-social";

export type SocialProps = UseSocialProps;

export const Social = (props: SocialProps) => {
  const { className, title, styles } = useSocial(props);

  return (
    <div className={styles.base({ className })}>
      {!!title && (
        <Typography
          className={styles.title()}
          fontSize="body-sm"
          spacing="widest"
          fontWeight="semibold"
          uppercase
        >
          {title}
        </Typography>
      )}
      <ul className={styles.list()}>
        {config.social.map(({ title, href }) => {
          const provider = `social-${title.toLowerCase()}` as SvgName;

          return (
            <li key={provider} className={styles.item()}>
              <NextLink href={href} title={title} className={styles.link()}>
                <Vector name={provider} className={styles.icon()} />
              </NextLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};
